export const prepareExpiredDateDescription = (data: string[]) =>
  data && data.length > 1 ? `+${data.length - 1}` : '';
